import { del, get, post } from "../../axios";
import { generateQueryParams } from "./api-contracts";
import { responseIsSuccessful } from "../../global-helpers";
import { simpleResponse } from "../api-helpers";

export async function getContractPlans(contractId) {
  const queryParams = generateQueryParams(contractId);
  return await get(`plans/${queryParams}`, window.localStorage.apiToken)
    .then(res => {
      if (responseIsSuccessful(res) && res.data.plans) {
        return res.data.plans;
      }
      return [];
    })
    .catch(err => {
      console.log(err);
      return [];
    });
}

export async function storeContractPlan(contractId, plan) {
  const formParams = new FormData();
  formParams.append("plan_params[contract_id]", contractId);
  formParams.append("plan_params[plan]", plan, plan.name);

  return simpleResponse(
    post("plans", formParams, window.localStorage.apiToken, true)
  );
}

export async function deletePlan(plan) {
  return simpleResponse(del(`plans/${plan.id}`, window.localStorage.apiToken));
}
